// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, {
  formatarData,
  validateToken,
  exibirMoeda,
} from "../../../components/Globais";

export const buscarPeriodosService = async (
  cotaId: number | null | undefined
) => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/periodo/cota/periodos/${cotaId}/${Token.id}`;
    try {
      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
      });

      const periodosArray = response.data.map((periodo: any) => {
        return {
          key: periodo.id,
          checkIn: formatarData(periodo.checkIn),
          checkOut: formatarData(periodo.checkOut),
          valor: exibirMoeda(periodo.valor),
          origem: periodo.origem === 0 ? "Multicotas" : "Usuário",
          dataEspecial: periodo.dataEspecial,
        };
      });

      return periodosArray;
    } catch (error) {
      console.error(error);
    }
  }
};
